// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { productGridContainerStyle } from "@rpsc/App/Components/Product/ProductGridTemplate";
import { xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

productGridContainerStyle.container = {
    css: css`
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        max-width: 319px;
        width: 100%;
        background-color: transparent;
        box-shadow: none;
        box-sizing: border-box;
        ${xScreen("lte", "md")} {
            max-width: 358px;
        }
        ${xScreen("lte", "xs")} {
            max-width: 100%;
        }
    `,
};

productGridContainerStyle.image = {
    css: css`
        position: relative;
    `,
};

productGridContainerStyle.info = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

productGridContainerStyle.priceAndActions = {
    css: css`
        display: flex;
        flex-direction: column;
        margin-top: auto;
        justify-content: space-between;
        gap: 8px;
    `,
};

productGridContainerStyle.addToList = {
    css: css`
        display: flex;
        width: 100%;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: 12px;
        &:empty {
            display: none;
        }
    `,
};

productGridContainerStyle.badges = {
    css: css`
        display: flex;
        gap: 8px;
        margin-bottom: 8px;
        align-items: center;
        flex-wrap: wrap;
        &:empty {
            display: none;
        }
        ${xScreen("lte", "sm")} {
            min-height: unset;
        }
    `,
};
